import { render, staticRenderFns } from "./Demo_Fregs.vue?vue&type=template&id=4baefeba&scoped=true&"
import script from "./Demo_Fregs.vue?vue&type=script&lang=js&"
export * from "./Demo_Fregs.vue?vue&type=script&lang=js&"
import style0 from "./Demo_Fregs.vue?vue&type=style&index=0&id=4baefeba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baefeba",
  null
  
)

export default component.exports